import "./index.css";

export function setupSelectSort() {
  const elements = document.querySelectorAll(".element-select-sort");

  if (elements.length > 0) {
    elements.forEach((element) => {
      const select = element.querySelector("select");
      const span = element.querySelector("span");

      if (!select || !span) return;

      span.textContent = select.options[select.selectedIndex].text;

      select.addEventListener("change", () => {
        span.textContent = select.options[select.selectedIndex].text;
      });
    });
  }
}
